import './index.erb';
import './index.rb';
import './index.scss';

(function ($) {
  $('.q-faq-icon a').click(function (e) {
    const $icon = $('.q-icon', e.currentTarget);
    $icon.toggleClass('q-icon-plus');
    $icon.toggleClass('q-icon-minus');
  });
})(jQuery);
